export default __webpack_public_path__ + "static/media/fitness.96c83320.png";